// extracted by mini-css-extract-plugin
export var author = "blockquote-module--author--qNNTD";
export var mark = "blockquote-module--mark--d9h3G";
export var sbShowMain = "blockquote-module--sb-show-main--B1p3B";
export var text = "blockquote-module--text--Qnv2L";
export var wrapper = "blockquote-module--wrapper--AvCQ5";